// extracted by mini-css-extract-plugin
export default {"container":"PowersAttorney_container__BuqsW","title":"PowersAttorney_title__DpLa8","button":"PowersAttorney_button__uFKvD"};